import type { GridDetailExpandChangeEvent } from "@tql/ui-components-react/kendo/grid";
import { useCallback, useMemo, useState } from "react";

import type { FreightGridRow } from "../../../types/freight-grid-row.ts";

/**
 * Per-row detail expand state keyed by `rowKey`. Only hazmat rows have a nested
 * detail row; they default to expanded and can be toggled, while non-hazmat rows
 * never expand.
 */
export const useHazmatDetailExpand = (rows: FreightGridRow[]) => {
	const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});

	const detailExpand = useMemo(() => {
		const map: Record<number, boolean> = {};
		for (const row of rows) {
			map[row.rowKey] =
				row.hazmat === true ? (expandedRows[row.rowKey] ?? true) : false;
		}
		return map;
	}, [rows, expandedRows]);

	const handleExpandChange = useCallback(
		(event: GridDetailExpandChangeEvent) => {
			setExpandedRows(event.detailExpand as Record<number, boolean>);
		},
		[],
	);

	return { detailExpand, handleExpandChange };
};
